import React from 'react';
import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, BtnPrimary, BtnSecondary, formatDate } from '../regureStyles';
import PermissionGate from '../../components/PermissionGate';

const Header = ({ setShowNew, policies }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.policiesScreen.operations')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.policiesScreen.breadcrumbPolicies')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.policiesScreen.pageTitle')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <PermissionGate resource='policies' action='create'>
          <BtnPrimary onClick={() => setShowNew(true)}>
            <Icon name='plus' color='#fff' size={16} /> {t('screens.policiesScreen.newPolicy')}
          </BtnPrimary>
        </PermissionGate>
        <BtnSecondary
          onClick={() => {
            const headers = ['Policy #', 'Client', 'Company', 'Product', 'Status', 'Premium', 'Start', 'End', 'Broker'];
            const rows = policies.map(p => [
              p.id,
              p.client,
              p.company,
              p.product,
              p.status,
              p.premium,
              p.start ? formatDate(p.start) : '',
              p.end ? formatDate(p.end) : '',
              p.broker,
            ]);
            const csv = [headers, ...rows].map(r => r.map(v => `"${String(v || '').replace(/"/g, '""')}"`).join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `policies-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
          }}
        >
          <Icon name='download' color={S.textMuted} size={15} /> {t('screens.policiesScreen.export')}
        </BtnSecondary>
      </div>
    </header>
  );
};

export default Header;
